import { InformationVariantBoxIcon } from './InformationVariantBoxIcon';

/**
 * author: Jeff Anders
 * id A146B034-84AF-47AD-BA0F-C2D779C95356
 * name information-variant-box
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-variant-box.svg
 * tags
 * - Settings 
 */
export const InfoSerifBoxIcon = InformationVariantBoxIcon;
export default InfoSerifBoxIcon